export default __webpack_public_path__ + "static/media/lamp.27da59bb.svg";